import { z } from 'zod';
import { knowledgeSignedPolicyConfigurationSchema } from './knowledge-library.contract.js';
export const knowledgeDocumentsSignedPolicyFactsCapability = 'knowledge.documents-signed-policy-facts.v1';
export const knowledgeDocumentsSignedPolicyAcknowledgementCapability = 'knowledge.documents-signed-policy-acknowledgement.v1';
export const knowledgeDocumentsSignedPolicyFactsSlot = 'documents.knowledge-signed-policy-facts';
export const knowledgeDocumentsSignedPolicyAcknowledgementSlot = 'documents.knowledge-signed-policy-acknowledgements';
export const knowledgeDocumentsSignedPolicyFactsProviderId = 'knowledge.server.documents-signed-policy-facts';
export const knowledgeDocumentsSignedPolicyAcknowledgementProviderId = 'knowledge.server.documents-signed-policy-acknowledgement';
export const knowledgeDocumentsSignedPolicyFactsRequestSchema = z.strictObject({
    consumerModuleId: z.literal('documents'),
    requestedCapability: z.literal('documents.knowledge-signed-policy-artifacts.v1'),
    resourceType: z.literal('documents.knowledge-signed-policy-artifact'),
    resourceId: z.string().uuid(),
    documentId: z.string().uuid(),
    expectedVersionId: z.string().uuid(),
});
export const knowledgeDocumentsSignedPolicyFactsResponseSchema = z.strictObject({
    state: z.literal('present'),
    capability: z.literal(knowledgeDocumentsSignedPolicyFactsCapability),
    tenantId: z.string().uuid(),
    membershipId: z.string().uuid(),
    documentId: z.string().uuid(),
    versionId: z.string().uuid(),
    versionNumber: z.number().int().positive(),
    title: z.string().trim().min(1).max(200),
    documentType: z.enum(['sop', 'policy', 'safety', 'reference', 'faq', 'guide']),
    bodyMarkdown: z.string().trim().min(1).max(500_000),
    sourceContentHash: z.string().regex(/^[a-f0-9]{64}$/),
    publishedAt: z.string().datetime({ offset: true }),
    signing: knowledgeSignedPolicyConfigurationSchema,
    factHash: z.string().regex(/^[a-f0-9]{64}$/),
});
export const knowledgeDocumentsSignedPolicyAcknowledgementRequestSchema = z.strictObject({
    consumerModuleId: z.literal('documents'),
    requestedCapability: z.literal(knowledgeDocumentsSignedPolicyAcknowledgementCapability),
    sourceCapability: z.literal('documents.knowledge-signed-policy-artifacts.v1'),
    commandId: z.string().uuid(),
    documentId: z.string().uuid(),
    versionId: z.string().uuid(),
    sourceContentHash: z.string().regex(/^[a-f0-9]{64}$/),
    signedProofHash: z.string().regex(/^[a-f0-9]{64}$/),
    acknowledgementText: z.string().trim().min(1).max(500),
});
export const knowledgeDocumentsSignedPolicyAcknowledgementResponseSchema = z.strictObject({
    state: z.literal('accepted'),
    capability: z.literal(knowledgeDocumentsSignedPolicyAcknowledgementCapability),
    tenantId: z.string().uuid(),
    documentId: z.string().uuid(),
    versionId: z.string().uuid(),
    membershipId: z.string().uuid(),
    acknowledgementId: z.string().uuid(),
    acknowledgedAt: z.string().datetime({ offset: true }),
    signedProofHash: z.string().regex(/^[a-f0-9]{64}$/).nullable(),
    proofBound: z.boolean(),
    idempotent: z.boolean(),
});
//# sourceMappingURL=knowledge-documents-signed-policy.contract.js.map